const _ = require('lodash');
const i18next = require('i18next');
const mapping = require('arbitrip-common/theme/mapping');
const { TRANSLATION_ENV } = require('arbitrip-common/translation/const');
const { THEME_PREFIX } = require('./const');

function addCompanyTranslation(translation_env, company_id, addResourceBundleFunc) {
    const company_theme_name = _.get(mapping, company_id);

    if (company_id && company_theme_name) {
        try {
            // Use company_id as the namespace
            const namespace = `${THEME_PREFIX}${company_id}`;

            if (!i18next.hasResourceBundle('en', namespace)) {
                // Update English translation
                const enThemeTranslation = require(`arbitrip-common/theme/translation/${translation_env}/en/${company_theme_name}.json`);
                addResourceBundleFunc('en', namespace, enThemeTranslation);
            }

            if (translation_env === TRANSLATION_ENV.MOBILE || translation_env === TRANSLATION_ENV.SERVER) {
                if (!i18next.hasResourceBundle('he', namespace)) {
                    // Update Hebrew translation for mobile and server
                    const heThemeTranslation = require(`arbitrip-common/theme/translation/${translation_env}/he/${company_theme_name}.json`);
                    addResourceBundleFunc('he', namespace, heThemeTranslation);
                }
            }
        } catch (error) {
            // console.error(`Error importing theme translation for company: ${company_theme_name}, on env: ${translation_env}`, error);
        }
    }
}

function isThemeExists(company_id) {
    const company_theme_name = _.get(mapping, company_id);
    return !!company_theme_name;
}

module.exports = {
    addCompanyTranslation,
    isThemeExists
}